import React, { ReactNode, useMemo } from 'react';
import { getPricingFields } from '@/services/projects';
import { Trans } from '@lingui/react/macro';
import { t } from '@lingui/core/macro';
import { PricingField } from '@/types';
import { useAsyncState } from '@/utils/hooks';
import { Select } from '@ygtechnologies/bygr-frontend-component-library';

interface PricingFieldSelectProps {
    projectId: number | null;
    onChange(pricingFieldId: number, pricingField: PricingField): void;
    value: number | null;
    disabled?: boolean;
}

interface Item {
    label: string | ReactNode;
    value: number | null;
    data?: PricingField | null;
}

export const PricingFieldSelect: React.FC<PricingFieldSelectProps> = ({ projectId, onChange, value, disabled }) => {
    const [pricingFields] = useAsyncState(
        () => (projectId ? getPricingFields(projectId) : Promise.resolve(null)),
        [projectId],
        null
    );

    const getText = (pricingField: PricingField) => {
        return <React.Fragment>{pricingField.name}</React.Fragment>;
    };

    const options = useMemo<Item[]>(() => {
        if (!pricingFields) {
            return [{ label: <Trans>Loading</Trans>, value: -1, data: null }];
        }

        return [
            { label: t`None`, value: null, data: null },
            ...pricingFields.map((pf) => ({ label: getText(pf), value: pf.id, data: pf })),
        ];
    }, [pricingFields]);

    return (
        <div>
            <Select
                isDisabled={disabled}
                placeholder={t`Select pricing variable`}
                onChange={(nw: any) => onChange(nw.value, nw.data)}
                value={options.find((dl) => dl.value === value) || null}
                options={options}
            />
        </div>
    );
};
